import React, { useRef } from 'react'
import Sidebar from './sidebar';
import CardContainer from './card_container';
import { isEmpty } from 'lodash'

const PreferredPartnersParent = ({ featuredPartners, recentlyAdded, categories, partners }) => {
  const refs = {};
  const createCategoryContainers = () => categories.map(({ id, name }) => {
    const partnersList = partners[id];
    if(isEmpty(partnersList)) return;

    const ref = useRef(null);
    refs[name] = ref;
    return (
      <CardContainer key={id}
                     partnersList={partners[id]}
                     title={name}
                     ref={ref} />
    )
  })

  const filteredCategories = categories.filter(category => !isEmpty(partners[category.id]))
                                       .map(category => category.name);
  return (
    <div className='container--extend pt-30 pb-6'>
      <div className='row'>
        <Sidebar
          categories={filteredCategories}
          refs={refs}
        />
        <main className='col-md-9'>
          <div className='placeholder'></div>
          {<CardContainer partnersList={featuredPartners} title={'Featured Partners'} classList={'mt--25'} />}
          <div className='placeholder'></div>
          {<CardContainer partnersList={recentlyAdded} title={'Recently Added'} />}
          {createCategoryContainers()}
          <div className='placeholder bottom'></div>
        </main>
      </div>
    </div>
  )
}

export default PreferredPartnersParent;
